import { BaseRestDataProvider } from './BaseRestDataProvider';
import { TaskItem } from '../models/TaskItem';

export class TaskItemRestDataProvider extends BaseRestDataProvider {
    constructor() {
        super('/v1/task-items');
    }

    getAll(): Promise<TaskItem[]> {
        return this.get<TaskItem[]>(``);
    }

    getById(id: string): Promise<TaskItem> {
        return this.get<TaskItem>(`/${id}`);
    }

    add(task: TaskItem): Promise<TaskItem> {
        return this.post<TaskItem>(``, task);
    }

    update(id: string, task: TaskItem): Promise<void> {
        return this.put<void>(`/${id}`, task);
    }

    complete(id: string): Promise<void> {
        return this.postVoid(`/${id}/complete`);
    }

    reopen(id: string): Promise<void> {
        return this.postVoid(`/${id}/reopen`);
    }

    delete(id: string): Promise<void> {
        return super.delete(`/${id}`);
    }
}

export type { TaskItem };

